import { translate } from '../i18n'
import { OptionTypeBase } from 'react-select/src/types'

export const ADD_DEVICE_FORM = 'ADD_DEVICE_FORM'
export const EDIT_DEVICE_FORM = 'EDIT_DEVICE_FORM'

export const getStatusLabel = (value: string) => {
  if (value === DEVICE_STATUS.FREE) {
    return 'Available'
  } else if (value === DEVICE_STATUS.ASSIGNED) {
    return 'Assigned'
  }

}
export const DEVICE_TYPE = {
  BP_MONITOR: 'BP_MONITOR',
  WEIGHT_SCALE: 'WEIGHT_SCALE',
}

export const DEVICE_STATUS = {
  FREE: 'FREE',
  ASSIGNED: 'ASSIGNED',
}

export const DEVICES: OptionTypeBase[] = [
  {
    label: `${translate('device.selectDeviceType')}`,
    value: ''
  },
  {
    label: `${translate('device.devices.weightScale')}`,
    value: DEVICE_TYPE.WEIGHT_SCALE
  },
  {
    label: `${translate('device.devices.bloodPressureMonitor')}`,
    value: DEVICE_TYPE.BP_MONITOR
  }
]

export const DEVICES_STATUS_OPTIONS: OptionTypeBase[] = [
  {
    label: `${translate('device.showAllDev')}`,
    value: ''
  },
  {
    label: `${translate('device.showAssDevLabel')}`,
    value: DEVICE_STATUS.ASSIGNED
  },
  {
    label: `${translate('device.showUnassDevLabel')}`,
    value: DEVICE_STATUS.FREE
  }
]

export const DEVICES_FILTER: OptionTypeBase[] = [
  {
    label: `${translate('device.showAllDevTypes')}`,
    value: ''
  },
  {
    label: `${translate('device.showWgtLabel')}`,
    value: DEVICE_TYPE.WEIGHT_SCALE
  },
  {
    label: `${translate('device.showBPLabel')}`,
    value: DEVICE_TYPE.BP_MONITOR
  }
]

export const DEVICES_STATUS_OPTIONS_FILTERS: OptionTypeBase[] = [
  {
    label: `${translate('device.showAllDev')}`,
    value: ''
  },
  {
    label: `${translate('device.showAssDevLabel')}`,
    value: DEVICE_STATUS.ASSIGNED
  },
  {
    label: `${translate('device.showUnassDevLabel')}`,
    value: DEVICE_STATUS.FREE
  }
]

export const getDeviceLabel = (type: string) => {
  switch (type) {
    case DEVICE_TYPE.WEIGHT_SCALE:
      return `${translate('device.devices.weightScale')}`
    case DEVICE_TYPE.BP_MONITOR:
      return `${translate('device.devices.bloodPressureMonitor')}`
    default:
      return ''
  }

}
export const  getDeviceStatusColor = (value: string) => {

  switch (value) {
    case DEVICE_STATUS.ASSIGNED:
      return '#27C24C'
    case DEVICE_STATUS.FREE:
      return '#0C89F3'
    default:
      return ''
  }
}

export const successfulEdit = translate('device.messages.deviceEditSuccess')!
export const successfulAdd = translate('device.messages.deviceAddSuccess')!
export const sucessfulDelete = translate('device.messages.deviceDeleteSuccess')!
